const COMPACT_EDITOR_FIELD_SELECTOR = [
  '.drag-field',
  '.node-value-input',
  '.scene-prop-input',
  '.value-color-field',
  '.value-color-value',
  '.param-color-field',
  '.param-color-value',
].join(', ');

const installedDocuments = new WeakSet<Document>();

export function shouldPreventEditorTextDrag(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.closest('textarea')) return false;
  return Boolean(target.closest(COMPACT_EDITOR_FIELD_SELECTOR));
}

export function installEditorTextDragGuards(doc: Document = document): void {
  if (installedDocuments.has(doc)) return;
  installedDocuments.add(doc);
  doc.addEventListener('dragstart', event => {
    if (shouldPreventEditorTextDrag(event.target)) {
      event.preventDefault();
    }
  }, true);
}
